module.exports = __webpack_public_path__ + "img/d-office.ec79249e.png";